import { ProductBuilderMachineContext } from '../types';
import { isShutters } from './isShutters';

type GetShippingOptions = (
  context: ProductBuilderMachineContext,
) => { freight: string; price: string }[];

export const getShippingOptions: GetShippingOptions = context => {
  const {
    productWithMeasurements,
    custom: { configuration = '' },
  } = context;

  if (!productWithMeasurements || typeof productWithMeasurements === 'string')
    return [];

  return productWithMeasurements.data
    .map(({ attributes: { freight, price } }) => {
      // Centre Opening Curtains - Only double price if NOT curtain type
      const isCurtain = context.products[0]?.type === 'Curtain';
      
      if (configuration.includes('Centre Opening') && parseInt(price) && !isCurtain) {
        price = (parseInt(price) * 2).toString();
      }

      return { freight, price };
    })
    .sort((item1, item2) => {
      return item2.freight.localeCompare(item1.freight);
    })
    .filter(item => (isShutters(context) ? item.freight === 'sea' : true));
};
